import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const wrapper = css`
  display: flex;
  justify-content: flex-start;
  max-width: 700px;
  flex-direction: row;
  flex-wrap: wrap;
  padding: ${theme.spacing(1, 1, 3, 1)};
  margin: ${theme.spacing(1, 0)};
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.neutral20};
  gap: ${theme.spacing(1)};

  & > form {
    margin: ${theme.spacing(1, 2)};
  }
`;

export const cardTextSpacing = css({
  marginBottom: theme.spacing(2),
  cursor: 'help',
  svg: {
    display: 'inline-block',
    opacity: 0.4,
    transform: 'translateY(2px)',
  },
});

export const leadTimeRow = (isSmallMode = false) => css`
  margin-bottom: ${theme.spacing(-2)};
  ${isSmallMode && 'flex-wrap: wrap;'}
  & > * {
    flex-basis: calc(50% - ${theme.spacing(2)});
  }
`;

export const leadTimeField = css({
  width: '160px',
  marginBottom: theme.spacing(2),
  textTransform: 'capitalize',
});

export const requiredApptTimeDropdown = css({
  maxWidth: '200px',
});

export const alertMargin = css({
  marginBottom: theme.spacing(2),
});
